import React, {ReactNode} from 'react'
import {Tab} from "@headlessui/react";
import {CardSkeleton} from "../CardSkeleton";

// Types ----

type PanelWrapperProps = {
  isLoading?: boolean
  children: ReactNode
}

// Component ----

function PanelWrapper({isLoading = false, children}: PanelWrapperProps) {
  return (
    <Tab.Panel className={`flex flex-col gap-3 h-[50vh] overflow-x-hidden pr-3 ${isLoading ? 'overflow-y-hidden' : 'overflow-y-auto'}`}>
      {children}
    </Tab.Panel>
  );
}

export {PanelWrapper};